import React from 'react';
import UtilitiesController from './utilitiesController';
import { Platform } from 'react-native';
import { config } from '../../config';
import AsyncStorage from '@react-native-async-storage/async-storage';

export default class AuthController {

    static exceptionWrapper = (fn) => async (data) => {
        try {
            return await fn(data).catch((err) => {
                throw err;
            });
        } catch (err) {
            return {
                success: false,
                error: err.message
            }
        }
    };

    static signOut = AuthController.exceptionWrapper(async () => {
        await AuthController.clearToken();
        await AsyncStorage.setItem('notification_carousel_displayed', 'false');
        await AsyncStorage.setItem('sign_up_step', 'phone_number_input');
    });

    static sendPhoneCode = AuthController.exceptionWrapper(async (data) => {
        let login_data = {
            ...data,
            partner: config.SELECTED_PARTNER,
            partner_name: 'DodoVet'
        }
        return await UtilitiesController.post('/v4/send_login_code', login_data, true);
    })

    static validatePhoneCode = AuthController.exceptionWrapper(async (data) => {
        data = {
            ...data,
            partner: config.SELECTED_PARTNER
        }

        let response = await UtilitiesController.post('/v4/verify_login_code', data, true);

        if(response && response.success && response.data) {
            let user = response.data.user;
            user = {
                ...user,
                token: response.data.token
            }
            await AuthController.setUser(user);
        }

        return response
    });

    static sendRegisterPhoneCode = AuthController.exceptionWrapper(async (data) => {
      let phone_code_data = {
        ...data,
        partner_name: 'DodoVet'
      }
        return await UtilitiesController.post('/v4/send_phone_code', phone_code_data, true);
    });

    static validateRegisterPhoneCode = AuthController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.post('/v4/validate_phone_code', data, true);

        if(response.success && response.data) {
            await AuthController.setUser(response.data);
        }

        return response
    });

    static completeRegistration = AuthController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.post('/v4/complete_registration', data, true);

        if(response.success && response.data) {
            await AuthController.setUser(response.data);
        }

        return response;
    });

    static createSubscription = AuthController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.post('/v3/api/care_subscription/create_subscription', data, true);

        if(response.success) {
            await AuthController.setUser(response);
        }

        return response;
    });

    static verifyCoupon = AuthController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.post('/v4/verify_coupon', data, true);

        return response;
    });

    static createPaymentIntentSubscription = AuthController.exceptionWrapper(async (data) => {
        console.log('data', data)
        let response = await UtilitiesController.post('/v4/api/user/payment_intent_subscription', data, true);

        console.log('after creating subscription', response);

        if(response.success) {
            await AuthController.setUser(response);
        }

        return response;
    });

    static loginWithPassword = AuthController.exceptionWrapper(async (data) => {

        let response = await UtilitiesController.post('/login', data, true);

        console.log('response', response)

        if(response.success) {
            await AuthController.setUser(response);
        }

        return response;
    });

    static getSubscription = AuthController.exceptionWrapper(async ({partner_name}) => {
        let response = await UtilitiesController.get(`/v4/subscription/${partner_name}`, {}, true);

        if(response.success && response.subscription) {
            await AsyncStorage.setItem('partner_id', response.subscription.partner_id);
        }

        return response;
    });

    static v3Test = AuthController.exceptionWrapper(async () => {
        let response = await UtilitiesController.post(`/v3/email_validation`, { code: "ABC" }, true).catch(err => {throw err})
        // console.log('v3Test response', response)
    });

    static v4Test = AuthController.exceptionWrapper(async () => {
        let response = await UtilitiesController.post(`/v4/verify_coupon`, {coupon_code: "testcode"}, true).catch(err => {throw err})
        // console.log('v4TEst response', response)
    });

    static getPaymentIntent = AuthController.exceptionWrapper(async (data) => {

        let response = await UtilitiesController.post(`/v4/payment_intent`, data, true);

        if(response.success && response.subscription) {
            await AsyncStorage.setItem('partner_id', response.subscription.partner_id);
        }

        return response;
    });

    static setUser = async (user) => {
        if(user.token) await AsyncStorage.setItem('token', user.token);
        if(user._id) await AsyncStorage.setItem('user_id', user._id);
        if(user.email) await AsyncStorage.setItem('email', user.email);
        if(user.first_name) await AsyncStorage.setItem('first_name', user.first_name);
        if(user.last_name) await AsyncStorage.setItem('last_name', user.last_name);
        if(user.phone_number) await AsyncStorage.setItem('phone_number', user.phone_number);
        if(user.photo_url) await AsyncStorage.setItem('photo_url', user.photo_url);
        if(user.state) await AsyncStorage.setItem('state', user.state);
        if(user.type) await AsyncStorage.setItem('type', user.type);
        if(user.bio) await AsyncStorage.setItem('bio', user.bio);
        if(user.last_signup_screen) await AsyncStorage.setItem('last_signup_screen', user.last_signup_screen);
        if(user.has_password) await AsyncStorage.setItem('has_password', user.has_password ? "true" : "false");
    }

    static clearToken = async (user) => {
      await AsyncStorage.removeItem('token');
      await AsyncStorage.removeItem('user_id');
      await AsyncStorage.removeItem('email');
      await AsyncStorage.removeItem('first_name');
      await AsyncStorage.removeItem('last_name');
      await AsyncStorage.removeItem('phone_number');
      await AsyncStorage.removeItem('photo_url');

      await AsyncStorage.removeItem('state');
      await AsyncStorage.removeItem('type');
      await AsyncStorage.removeItem('bio');
      await AsyncStorage.removeItem('last_signup_screen');
      await AsyncStorage.removeItem('has_password');
    }

    static getLoggedInUser = AuthController.exceptionWrapper(async () => {
        let response = await UtilitiesController.get(`/v4/api/user`, {}, true);

        if(response.success && response.data) await AuthController.setUser(response.data);

        return response;
    });

    static getPartnerDetails = AuthController.exceptionWrapper(async () => {
        let response     = await UtilitiesController.get(`/v4/api/partner_details/${config.SELECTED_PARTNER}`, {}, true);
        let partner_id   = response && response.data && response.data.partner_details && response.data.partner_details._id  ? response.data.partner_details._id  : '';
        let partner_code = response && response.data && response.data.partner_details && response.data.partner_details.code ? response.data.partner_details.code : '';

        if (partner_id) {
          await AsyncStorage.setItem('partner_id', partner_id);
          await AsyncStorage.setItem('partner_code', partner_code);
        }
    });

    static getAsyncStorageBoolean = async (name) => {
        let async_item = await AsyncStorage.getItem(name);

        if(!async_item) return false;

        return async_item === "true";
    }

    static getUser = async (get_new) => {
        if(get_new) {
            await AuthController.getLoggedInUser();
        }

        let user = {
            token: await AsyncStorage.getItem('token'),
            user_id: await AsyncStorage.getItem('user_id'),
            email: await AsyncStorage.getItem('email'),
            first_name: await AsyncStorage.getItem('first_name'),
            last_name: await AsyncStorage.getItem('last_name'),
            phone_number: await AsyncStorage.getItem('phone_number'),
            photo_url: await AsyncStorage.getItem('photo_url'),
            state: await AsyncStorage.getItem('state'),
            type: await AsyncStorage.getItem('type'),
            bio: await AsyncStorage.getItem('bio'),
            last_signup_screen: await AsyncStorage.getItem('last_signup_screen'),
            has_password: await AuthController.getAsyncStorageBoolean('has_password')
        }

        return user;
    }

    static createCheckoutSession = AuthController.exceptionWrapper(async (data) => {
        let redirect_domain = config.app_domain;
        data = {
            ...data,
            redirect_domain
        }

        let response = await UtilitiesController.post('/v4/api/user/create_checkout_session', data, true);

        return response;
    });

    static createSinglePaymentIntentCheckout = AuthController.exceptionWrapper(async (data) => {
        let redirect_domain = config.app_domain;

        data = {
            ...data,
            redirect_domain
        }

        let response = await UtilitiesController.post('/v4/api/user/create_payment_intent_checkout_session', data, true);

        return response;
    });

    static checkPaymentIntentStatus = AuthController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.post('/v4/api/user/check_payment_intent_status', data, true);
        return response;
    });

    static startSignupSession = AuthController.exceptionWrapper(async (data) => {
        let sign_up_session_id = await AsyncStorage.getItem("sign_up_session_id");

        if(!sign_up_session_id) {
            sign_up_session_id = await AuthController.createCareSignUpSession();
        }

        return sign_up_session_id;
    });

    static createCareSignUpSession = AuthController.exceptionWrapper(async () => {
        let response = await UtilitiesController.post('/v4/new_sign_up_session', {}, true);

        console.log('response', response)

        if(response.success) {
            let sign_up_session_id = response.data.care_session._id;
            await AsyncStorage.setItem("sign_up_session_id", sign_up_session_id);

            let platform = Platform.OS;

            await AuthController.updateCareSignUpSession({ sign_up_session_id,  platform });

            return response.data.care_session._id;
        }

        return null;
    });

    static updateCareSignUpSession = AuthController.exceptionWrapper(async (data) => {
      let sign_up_session_id = await AsyncStorage.getItem("sign_up_session_id");

      if (sign_up_session_id) {
        let update_data = {
          sign_up_session_id: sign_up_session_id,
          ...data
        }
        let response = await UtilitiesController.put(`/v4/sign_up_session/${sign_up_session_id}`, data, true);
      }

      return { };
    });

    static clearSignUpSession = AuthController.exceptionWrapper(async (data) => {
      await AsyncStorage.setItem("sign_up_session_id", '');
    });

    static singleEmailSignUpSignIn = AuthController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.post('/v4/signup_signin', data, true);
        return response;
    });

    static singleEmailSignUpSignInCodeVerify = AuthController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.post('/v4/signup_signin_verify', data, true);

        if(response.success) {
          await AuthController.setUser(response);
          await AuthController.getLoggedInUser();
        }

        return response;
    });
}
